import { render, staticRenderFns } from "./CheckoutProfileMerge.vue?vue&type=template&id=0838b828"
import script from "./CheckoutProfileMerge?vue&type=script&lang=ts&external"
export * from "./CheckoutProfileMerge?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports